module.exports = __webpack_public_path__ + "static/media/createIp.3fb88e03.png";